import StrUtils from "utils/StrUtils";
import { SelectPicker } from "rsuite";
import FieldUtils from "utils/FieldUtils";
import _ from "underscore";

const FilterSelectInput = ({
  currentFilter,
  filters,
  handleSelectChange,
  groupIndex,
  filterIndex,
  selectType,
  availableFields,
  getFieldByAPIName,
  getRecordSummaryField,
  subitemFieldsOnly,
}) => {
  const option = (name, value, source) => {
    return {
      label: name,
      value: value,
      source: source,
    };
  };

  const mapFieldOptions = (groupIndex) => {
    return availableFields[groupIndex].flatMap((field, i) => {
      const result = [];

      const subitemOptions = FieldUtils.getSubitemOptions(
        field,
        (name, value) => option(name, value)
      );
      const recordSummaryOptions = FieldUtils.getRecordSummaryOptions(
        field,
        (name, value, source) => option(name, value, source)
      );

      // Add base field first
      if (!subitemFieldsOnly && !subitemOptions) {
        result.push(option(field.Name, field.APIName));
      }

      // Add field's additional fields if necessary.
      if (subitemOptions) {
        if (subitemFieldsOnly) {
          subitemFieldsOnly === field.APIName && result.push(...subitemOptions);
        } else {
          result.push(...subitemOptions);
        }
      } else if (recordSummaryOptions) {
        !subitemFieldsOnly && result.push(...recordSummaryOptions);
      } else if (field.FieldType === "Location") {
        result.push(
          option(`${field.Name} Address 1`, `${field.Name}.Address.Address1`)
        );
        result.push(
          option(`${field.Name} Address 2`, `${field.Name}.Address.Address2`)
        );
        result.push(option(`${field.Name} City`, `${field.Name}.Address.City`));
        result.push(
          option(`${field.Name} State`, `${field.Name}.Address.StateProvince`)
        );
        result.push(
          option(`${field.Name} Zip Code`, `${field.Name}.Address.ZipCode`)
        );
        result.push(
          option(`${field.Name} Country`, `${field.Name}.Address.Country`)
        );
        result.push(option(`${field.Name} Type`, `${field.Name}.Address.Type`));
        result.push(
          option(
            `${field.Name} Description`,
            `${field.Name}.Address.Description`
          )
        );
      }

      return result;
    });
  };

  const mapMethodOptions = (fieldAPIName) => {
    const splitString = fieldAPIName.split(".");
    // Handle Subitem Fields, they will have dot separated names.

    const field = availableFields[0].find(
      (element) => splitString[0] === element.APIName
    );

    if (splitString.length > 1 && field.FieldType === "Location") {
      const field = getFieldByAPIName(splitString[0]);
      const methods = StrUtils.getFilterMethodsByFieldType(field.FieldType);
      return methods.map((method) => {
        return option(method.Name, method.Value);
      });
    }

    if (splitString.length > 1) {
      const parentField = getFieldByAPIName(splitString[0]);
      let subitemField = null;
      if (parentField.RecordSummary && currentFilter.Source) {
        subitemField = getRecordSummaryField(
          currentFilter.Source,
          splitString[1]
        );
      } else {
        subitemField = _.findWhere(parentField.SubitemFields, {
          APIName: splitString[1],
        });
      }

      const methods = StrUtils.getFilterMethodsByFieldType(
        subitemField.FieldType
      );

      return methods.map((method) => {
        return option(method.Name, method.Value);
      });
    }

    const fieldType = getFieldByAPIName(fieldAPIName)?.FieldType ?? null;
    const methods = StrUtils.getFilterMethodsByFieldType(fieldType);

    return methods.map((method, i) => option(method.Name, method.Value));
  };

  return (
    <SelectPicker
      size="sm"
      cleanable={false}
      preventOverflow
      data={
        selectType === "Field"
          ? mapFieldOptions(groupIndex)
          : mapMethodOptions(currentFilter.Field)
      }
      searchable={selectType === "Field"}
      block
      placeholder={selectType === "Field" ? "Select Field" : "Select Method"}
      value={filters[groupIndex].Filters[filterIndex][selectType]}
      onSelect={(_, item) => {
        handleSelectChange(
          { value: item?.value, source: item?.source },
          groupIndex,
          filterIndex,
          selectType
        );
      }}
    />
  );
};

export default FilterSelectInput;
